import type { FaireProductEntity } from "../../entity_types/product";

export const p_ghqv6tw2mz: FaireProductEntity = {
  token: "p_ghqv6tw2mz",
  type: "product",
  name: "OPEN FRONT CASUAL LONG CARDIGAN WITH SIDE POCKETS",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e14dc9cc95089f3429a4b5964b37a6b485c1e31fc15cf066aea950f5464412be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01f5f811a70e1e67364069cd48032e2cdb02e1a33710b473375cc2be73480092.jpeg",
    "https://cdn.faire.com/fastly/dffd281370b48a1b644f4dd77cd8a49059565676b5298830b5fa2329e97dd6aa.jpeg",
    "https://cdn.faire.com/fastly/e5aba82c298699f428ced1d69259715a0aa23fe45006b94375331f68673e7db3.jpeg",
    "https://cdn.faire.com/fastly/9de188aa9aa59c00e4c0c01292c57a89e0187856370f283439c867bbdb586296.jpeg",
    "https://cdn.faire.com/fastly/634afdadf25f8a4227469c9227324ab87843776c63ead94ad88971b2de56ab5f.jpeg",
    "https://cdn.faire.com/fastly/ad783269c88374524e92c39a52afa2770b29ef7f96d65c4b3ba60c4699c6bdaa.jpeg",
    "https://cdn.faire.com/fastly/91646acb94bbc9c17bbd34447e9b211bca1332648fee5b6176bc535fb6cf76dc.jpeg",
    "https://cdn.faire.com/fastly/dd16d0d672ae92ea074308e2d368bfc990d6e0465878559ed05cf3f6ed254727.jpeg",
    "https://cdn.faire.com/fastly/d4b501a61c6725530ef357744840233f0e5e53008cd5a65ed439314b4a399de7.jpeg",
    "https://cdn.faire.com/fastly/32acb08fee49b2fc1242cbdd190388cbc8fb942cf82bdcb31027e107edb8a35a.jpeg",
    "https://cdn.faire.com/fastly/f48b4dd1fbd47b74843e6338d2b1208b0beb39084cea018b5b426d7f72e4a421.jpeg",
    "https://cdn.faire.com/fastly/6909e943bbb30a3c251801ee9552152881bba5c0c85ae45679d5284834fa90df.jpeg",
    "https://cdn.faire.com/fastly/f26f6bbc62171fd8e968004e7885fb70c8522188e1593148db2bda8f90c6395c.jpeg",
    "https://cdn.faire.com/fastly/430946e7901ca30a71c1010beba3914043afe7e8ff7343c4f685bfa6581442d5.jpeg",
    "https://cdn.faire.com/fastly/6ead615c290c8c88c4cc3091f44ed656f432636d7773b9e83db397a63c5d5354.jpeg",
  ],
  priceDollars: 18.02,
  description:
    "OPEN FRONT CASUAL LONG CARDIGAN WITH SIDE POCKETS\n95% POLYESTER, 5% SPANDEX\nSIZE  S / M / L / XL\nMADE IN CHINA\n\n* MODEL IS 5'7\" AND IS WEARING A SIZE SMALL",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:43.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
